module.exports = __webpack_public_path__ + "media/images/flags/1x1/che-2a21ed554b01f92d6ba88d69b6a254d7.svg";